<div class="innerBanner">
    <div class="container md">
        <div class="userCoures">
            <div class="row">
                <div class="col-12 col-lg-8">
                    <div class="userCouresLatest">
                        <span class="userCouresImage" style="background: url(assets/images/demo.png);" ></span>
                        <div class="userCouresContent">
                            <h3>Dummy Course Name</h3>
                            <p><span>32 Modules</span><span>54 Sub Modules</span></p>
                           <p>
                               <span>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</span>
                            </p>
                            <p class="mt-2"><span>Assigned on 13 Dec, 2020</span><span>Last Viewed on 27 Dec,2020</span></p>
                            <div class="resumWrap mt-2">
                                <span><img src="assets/images/icons/play_circle_filled.svg" /></span>
                                <div class="moduelWrap">
                                    <a href="javascript:void(0);" class="btn-link">Module 1</a>
                                    <a href="javascript:void(0);" class="btn-link d-none">Sub Module 3</a>
                                    <button class="btn btn-primary">Module Assessment 3<sup>RD</sup> Attempt</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-12 col-lg-4">
                    <div class="" (click)="showDetailsEvent()"  [ngClass]="showDetails ? 'mobileShowView active' : 'mobileShowView'">View Full Details</div>
                    <ul class="row" [ngClass]="showDetails ? 'mobileViews active' : 'mobileViews'">
                        <li class="col-12 col-md-6">
                            <div class="joinerDetails">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/doughnut_chart.svg" >
                                </span>
                                <div class="joinerContent">
                                    <h3>25%</h3>
                                    <p>Percentage of  course completed</p>
                                </div>
                            </div>
                        </li>
                        <li class="col-12 col-md-6">
                            <div class="ghrapWrap">
                                <span style="width: 25%;"></span>
                            </div>
                        </li>
                        <li class="col-12 col-md-6">
                            <div class="joinerDetails">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/clock.svg" >
                                </span>
                                <div class="joinerContent">
                                    <h3>20 hr 43 min</h3>
                                    <p>Time spent on course</p>
                                </div>
                            </div>
                        </li>
                        <li class="col-12 col-md-6">
                            <div class="joinerDetails">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/book.svg" >
                                </span>
                                <div class="joinerContent">
                                    <h3>12 modules</h3>
                                    <p>Modules Completed</p>
                                </div>
                            </div>
                        </li>
                        <li class="col-12 col-md-6">
                            <div class="joinerDetails">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/assessments.svg" >
                                </span>
                                <div class="joinerContent">
                                    <h3>9 / 12 passed</h3>
                                    <p>No. of Assessments passed</p>
                                </div>
                            </div>
                        </li>
                        <li class="col-12 col-md-6">
                            <div class="joinerDetails">
                                <span class="joinerDetailsImage">
                                    <img src="assets/images/icons/time.svg" >
                                </span>
                                <div class="joinerContent">
                                    <h3>15 min</h3>
                                    <p>Total Spent on assessment</p>
                                </div>
                            </div>
                        </li>
                    </ul>

                </div>
            </div>
        </div>
    </div>
</div>
<div class="tabsWrap">
    <div class="container md">
          <mat-tab-group animationDuration="0ms" [selectedIndex]="activeTab">
            <mat-tab>
                <ng-template mat-tab-label>
                    <b>Module 1:</b> Beginner level Introduction to Barrel Engine
                    <strong class="onGoing"><i>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.6989 5.46789H5.59336H6.7668H8.37049C8.52695 5.50701 9.42658 5.74169 9.42658 6.8369V10.5919C9.42658 11.3742 8.80075 12 8.05757 12H1.40812C0.625831 12 0 11.3742 0 10.5919V6.8369C0.0391144 6.21107 0.469373 5.66346 1.05609 5.50701V3.47306C1.0952 0.500359 4.41993 -0.829532 6.68857 0.539473C7.5 1.02913 8.37049 2 8.37049 3.64649H6.7668V3.5904C6.61034 0.969732 2.81624 0.969732 2.6989 3.5904V5.46789ZM4.73285 6.8369C5.5 6.8369 6 8 5 8.5V9.5C5 9.96937 4.5 9.96937 4.5 9.5V8.5C3.5 8 4 6.8369 4.73285 6.8369Z" fill="white"/>
                          </svg>
                        </i>UNLOCKED</strong>
                    </ng-template>
                    <div class="contentBody">
                        <div class="pl-4 mt-3 pr-4">
                            <div class="moduleHead">
                                
                                <div class="mudleSubHead">
                                <h3><b>Module 1:</b>Introduction to Motor Engine Rerouting</h3>
                                <ul class="modifyIcons">
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                    </li>
                                </ul>
                            </div>
                            </div>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    
                              <p class="assignOn text-left mt-2 mb-2"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                              <div class="row m-0">
                                  <div class="grapgReaWrap">
                                    <ul>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/doughnut_chart.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>15%</h3>
                                                    <p>Percentage of  course completed</p>
                                                    <div class="ghrapWrap">
                                                        <span style="width: 15%;"></span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </li>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/clock.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>20 hr 43 min</h3>
                                                    <p>Time spent on course</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/time.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>43 min</h3>
                                                    <p>Spent on assessment</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/gps.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>2/3</h3>
                                                    <p>No. of Attempts</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);" [routerLink]="['/viewer-details']" class="mudleBtn">
                                                Module Assessment 3<sup>RD</sup> Attempt </a>
                                        </li>
                                    </ul>
                                  </div>
                            </div>
                        </div>
                        <hr/>
                        <div class="submudleWrap">
                        <mat-accordion>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div class="moduleHead">
                                        
                                        <div class="submudleHead">
                                            <h3 ><b>SUB MODULE 1:</b>Safety & Precautions with Barrel Engine</h3>
                                            <div class="viewpass">
                                                <a href="javascript:void(0);" class="btn-link text-uppercase">View</a>
                                                <a href="javascript:void(0);" class="btn-link-green text-uppercase">Completed</a>
                                            </div>
                                            <ul class="modifyIcons">
                                                
                                                <li>
                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    
                                <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                <div class="row m-0">
                                  <div class="col-12 col-md-4">
                                      <div class="joinerDetails mb-md-0">
                                          <span class="joinerDetailsImage">
                                              <img src="assets/images/icons/doughnut_chart.svg" >
                                          </span>
                                          <div class="joinerContent">
                                              <h3>15%</h3>
                                              <p>Percentage of  course completed</p>
                                          </div>
                                          
                                      </div>
                                  </div>
                                  <div class="col-12 col-md-4">
                                      <div class="joinerDetails mb-md-0">
                                          <span class="joinerDetailsImage">
                                              <img src="assets/images/icons/clock.svg" >
                                          </span>
                                          <div class="joinerContent">
                                              <h3>20 hr 43 min</h3>
                                              <p>Time spent on course</p>
                                          </div>
                                      </div>
                                  </div>
           
                                </div>
                            </mat-expansion-panel>
                            
                            <mat-expansion-panel (opened)="panelOpenState = true"
                                                 (closed)="panelOpenState = false">
                                                 <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <div class="moduleHead">
                                                            
                                                            <div class="submudleHead">
                                                            <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                                            <div class="viewpass">
                                                                <a href="javascript:void(0);" class="btn-link text-uppercase">View</a>
                                                                <a href="javascript:void(0);" class="btn-link-green text-uppercase">Passed</a>
                                                            </div>
                                                            <ul class="modifyIcons">
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                    </mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        
                                                    <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                    <div class="row m-0">
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/doughnut_chart.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>15%</h3>
                                                                  <p>Percentage of  course completed</p>
                                                              </div>
                                                              
                                                          </div>
                                                      </div>
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/clock.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>20 hr 43 min</h3>
                                                                  <p>Time spent on course</p>
                                                              </div>
                                                          </div>
                                                      </div>
                               
                                                    </div>
                            </mat-expansion-panel>
                            <mat-expansion-panel (opened)="panelOpenState = true"
                                                 (closed)="panelOpenState = false">
                                                 <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <div class="moduleHead">
                                                            
                                                            <div class="submudleHead">
                                                            <h3><b>SUB MODULE 2:</b>Advanced level Introduction to Barrel Engine</h3>
                                                            <div class="viewpass">
                                                                <a href="javascript:void(0);" class="btn-link text-uppercase">View</a>
                                                                <a href="javascript:void(0);" class="btn-link-green text-uppercase">Completed</a>
                                                            </div>
                                                            <ul class="modifyIcons">
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                    </mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        
                                                    <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                    <div class="row m-0">
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/doughnut_chart.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>15%</h3>
                                                                  <p>Percentage of  course completed</p>
                                                              </div>
                                                              
                                                          </div>
                                                      </div>
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/clock.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>20 hr 43 min</h3>
                                                                  <p>Time spent on course</p>
                                                              </div>
                                                          </div>
                                                      </div>
                               
                                                    </div>
                            </mat-expansion-panel>
                            <mat-expansion-panel (opened)="panelOpenState = true"
                                                 (closed)="panelOpenState = false">
                                                 <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <div class="moduleHead">
                                                            
                                                            <div class="submudleHead">
                                                            <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                                            <div class="viewpass">
                                                                
                                                                <a href="javascript:void(0);" class="btn-link text-uppercase">View</a>
                                                                <a href="javascript:void(0);" class="btn-link-green text-uppercase">Completed</a>
                                                            </div>
                                                            <ul class="modifyIcons">
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                    </mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        
                                                    <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                    <div class="row m-0">
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/doughnut_chart.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>15%</h3>
                                                                  <p>Percentage of  course completed</p>
                                                              </div>
                                                              
                                                          </div>
                                                      </div>
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/clock.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>20 hr 43 min</h3>
                                                                  <p>Time spent on course</p>
                                                              </div>
                                                          </div>
                                                      </div>
                               
                                                    </div>
                            </mat-expansion-panel>
                            <mat-expansion-panel (opened)="panelOpenState = true"
                            (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                               <mat-panel-title>
                                   <div class="moduleHead">
                                       
                                       <div class="submudleHead">
                                       <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                       <div class="viewpass">
                                           
                                        <a href="javascript:void(0);" class="btn-link text-uppercase">View</a>
                                        <a href="javascript:void(0);" class="btn-link-green text-uppercase">Completed</a>
                                       </div>
                                       <ul class="modifyIcons">
                                           <li>
                                               <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                           </li>
                                           <li>
                                               <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                           </li>
                                           <li>
                                               <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                           </li>
                                       </ul>
                                   </div>
                                   </div>
                               </mat-panel-title>
                               </mat-expansion-panel-header>
                               <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    
                               <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                               <div class="row m-0">
                                 <div class="col-12 col-md-4">
                                     <div class="joinerDetails mb-md-0">
                                         <span class="joinerDetailsImage">
                                             <img src="assets/images/icons/doughnut_chart.svg" >
                                         </span>
                                         <div class="joinerContent">
                                             <h3>15%</h3>
                                             <p>Percentage of  course completed</p>
                                         </div>
                                         
                                     </div>
                                 </div>
                                 <div class="col-12 col-md-4">
                                     <div class="joinerDetails mb-md-0">
                                         <span class="joinerDetailsImage">
                                             <img src="assets/images/icons/clock.svg" >
                                         </span>
                                         <div class="joinerContent">
                                             <h3>20 hr 43 min</h3>
                                             <p>Time spent on course</p>
                                         </div>
                                     </div>
                                 </div>
          
                               </div>
       </mat-expansion-panel>
                          </mat-accordion>
                        </div>
                           
                        </div>
            </mat-tab>
            
            <mat-tab disabled>
                <ng-template mat-tab-label>
                    <b>Module 2:</b>Beginner level Introduction to Barrel Engine
                    <strong><i><svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.94252 5.29354H1.15307L1.15669 3.33606C1.20032 2.41276 1.60032 1.5852 2.22032 0.986142L2.2252 0.98126C2.85685 0.373701 3.71465 0 4.65402 0C5.59512 0 6.45528 0.374961 7.08772 0.986142C7.71921 1.59669 8.12284 2.44441 8.15354 3.38866L8.15528 5.29354H8.36551C8.6252 5.29354 8.86221 5.4 9.03181 5.56976L9.07732 5.62094C9.22079 5.78709 9.30803 6.0022 9.30803 6.23606V11.0575C9.30803 11.3172 9.20158 11.5542 9.03181 11.7238C8.86221 11.8935 8.6252 12 8.36551 12H0.94252C0.682835 12 0.445827 11.8935 0.276221 11.7238C0.106457 11.5542 0 11.3172 0 11.0575V6.23606C0 5.97858 0.105984 5.74346 0.276221 5.57197C0.445827 5.4 0.682835 5.29354 0.94252 5.29354ZM4.65402 7.00425C5.00236 7.00425 5.28472 7.28661 5.28472 7.63496C5.28472 7.91039 5.10835 8.14425 4.86236 8.23039V8.7211V9.90709C4.86236 10.0508 4.74589 10.1672 4.60221 10.1672C4.4567 10.1672 4.33874 10.0493 4.33874 9.90377V8.7211V8.23039C4.09276 8.14425 3.96008 7.91039 3.96008 7.63496C3.96008 7.28661 4.30567 7.00425 4.65402 7.00425ZM2.28362 5.29354H7.02441V3.40646C7.00079 2.77433 6.72819 2.2074 6.30551 1.79858C5.87795 1.38425 5.29543 1.13134 4.65402 1.13134C4.01307 1.13134 3.43087 1.38394 3.00551 1.79543C2.5852 2.20252 2.31386 2.76063 2.28315 3.38331L2.28362 5.29354Z" fill="white"/>
                        </svg></i></strong>
                </ng-template>
                <div class="contentBody">
                    <div class="pl-4 mt-4 pr-4">
                        <div class="moduleHead">
                            <b>Module 1:</b>
                            <div class="mudleSubHead">
                            <h3>Introduction to Motor Engine Rerouting</h3>
                            <ul class="modifyIcons">
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                </li>
                            </ul>
                        </div>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

                          <p class="assignOn text-left mt-2 mb-2"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                          <div class="row m-0">
                              <div class="grapgReaWrap">
                                <ul>
                                    <li>
                                        <div class="joinerDetails mb-md-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/doughnut_chart.svg" >
                                            </span>
                                            <div class="joinerContent">
                                                <h3>15%</h3>
                                                <p>Percentage of  course completed</p>
                                                <div class="ghrapWrap">
                                                    <span style="width: 15%;"></span>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </li>
                                    <li>
                                        <div class="joinerDetails mb-md-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/clock.svg" >
                                            </span>
                                            <div class="joinerContent">
                                                <h3>20 hr 43 min</h3>
                                                <p>Time spent on course</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="joinerDetails mb-md-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/time.svg" >
                                            </span>
                                            <div class="joinerContent">
                                                <h3>43 min</h3>
                                                <p>Spent on assessment</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="joinerDetails mb-md-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/gps.svg" >
                                            </span>
                                            <div class="joinerContent">
                                                <h3>2/3</h3>
                                                <p>No. of Attempts</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="text-right">
                                        <a href="javascript:void(0);" class="reset_request_btn" (click)="open(content)">
                                            Reset request sent to administrator </a>
                                    </li>
                                </ul>
                              </div>
                        </div>
                    </div>
                    <hr/>
                    <div class="submudleWrap">
                    <mat-accordion>
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="moduleHead">
                                    
                                    <div class="submudleHead">
                                        <h3 ><b>SUB MODULE 1:</b>Safety & Precautions with Barrel Engine</h3>
                                        <div class="viewpass">
                                            <a href="javascript:void(0);" [routerLink]="['/viewer']" class="btn-link text-uppercase">View</a>
                                            <a href="javascript:void(0);" class="btn-link-green text-uppercase">Completed</a>
                                        </div>
                                        <ul class="modifyIcons">
                                            
                                            <li>
                                                <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

                            <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                            <div class="row m-0">
                              <div class="col-12 col-md-4">
                                  <div class="joinerDetails mb-md-0">
                                      <span class="joinerDetailsImage">
                                          <img src="assets/images/icons/doughnut_chart.svg" >
                                      </span>
                                      <div class="joinerContent">
                                          <h3>15%</h3>
                                          <p>Percentage of  course completed</p>
                                      </div>
                                      
                                  </div>
                              </div>
                              <div class="col-12 col-md-4">
                                  <div class="joinerDetails mb-md-0">
                                      <span class="joinerDetailsImage">
                                          <img src="assets/images/icons/clock.svg" >
                                      </span>
                                      <div class="joinerContent">
                                          <h3>20 hr 43 min</h3>
                                          <p>Time spent on course</p>
                                      </div>
                                  </div>
                              </div>
       
                            </div>
                        </mat-expansion-panel>
                        
                        <mat-expansion-panel (opened)="panelOpenState = true"
                                             (closed)="panelOpenState = false">
                                             <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <div class="moduleHead">
                                                        
                                                        <div class="submudleHead">
                                                        <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                                        <div class="viewpass">
                                                            <a href="javascript:void(0);" [routerLink]="['/viewer']" class="btn-link text-uppercase">View</a>
                                                            <a href="javascript:void(0);" class="btn-link-green text-uppercase">Passed</a>
                                                        </div>
                                                        <ul class="modifyIcons">
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    </div>
                                                </mat-panel-title>
                                                </mat-expansion-panel-header>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    
                                                <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                <div class="row m-0">
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/doughnut_chart.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>15%</h3>
                                                              <p>Percentage of  course completed</p>
                                                          </div>
                                                          
                                                      </div>
                                                  </div>
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/clock.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>20 hr 43 min</h3>
                                                              <p>Time spent on course</p>
                                                          </div>
                                                      </div>
                                                  </div>
                           
                                                </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true"
                                             (closed)="panelOpenState = false">
                                             <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <div class="moduleHead">
                                                        
                                                        <div class="submudleHead">
                                                        <h3><b>SUB MODULE 2:</b>Advanced level Introduction to Barrel Engine</h3>
                                                        <div class="viewpass">
                                                            <a href="javascript:void(0);" class="btn-link text-uppercase">View</a>
                                                            <a href="javascript:void(0);" class="btn-link-green text-uppercase">Completed</a>
                                                        </div>
                                                        <ul class="modifyIcons">
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    </div>
                                                </mat-panel-title>
                                                </mat-expansion-panel-header>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    
                                                <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                <div class="row m-0">
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/doughnut_chart.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>15%</h3>
                                                              <p>Percentage of  course completed</p>
                                                          </div>
                                                          
                                                      </div>
                                                  </div>
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/clock.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>20 hr 43 min</h3>
                                                              <p>Time spent on course</p>
                                                          </div>
                                                      </div>
                                                  </div>
                           
                                                </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true"
                                             (closed)="panelOpenState = false">
                                             <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <div class="moduleHead">
                                                        
                                                        <div class="submudleHead">
                                                        <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                                        <div class="viewpass">
                                                            
                                                            <div class="locked">
                                                                <span mat-raised-button matTooltipClass="custom-tooltip"
                                                                        matTooltip="This section would only be unlocked once the previous section is completed by you"
                                                                        aria-label="Button that displays a tooltip when focused or hovered over">
                                                                        LOCKED
                                                            </span>
                                                            </div>
                                                        </div>
                                                        <ul class="modifyIcons">
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    </div>
                                                </mat-panel-title>
                                                </mat-expansion-panel-header>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    
                                                <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                <div class="row m-0">
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/doughnut_chart.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>15%</h3>
                                                              <p>Percentage of  course completed</p>
                                                          </div>
                                                          
                                                      </div>
                                                  </div>
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/clock.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>20 hr 43 min</h3>
                                                              <p>Time spent on course</p>
                                                          </div>
                                                      </div>
                                                  </div>
                           
                                                </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true"
                        (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                           <mat-panel-title>
                               <div class="moduleHead">
                                   
                                   <div class="submudleHead">
                                   <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                   <div class="viewpass">
                                       
                                    <button class="btn btn-primary">Start 1<sup>ST</sup> attempt</button>
                                   </div>
                                   <ul class="modifyIcons">
                                       <li>
                                           <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                       </li>
                                       <li>
                                           <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                       </li>
                                       <li>
                                           <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                       </li>
                                   </ul>
                               </div>
                               </div>
                           </mat-panel-title>
                           </mat-expansion-panel-header>
                           <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

                           <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                           <div class="row m-0">
                             <div class="col-12 col-md-4">
                                 <div class="joinerDetails mb-md-0">
                                     <span class="joinerDetailsImage">
                                         <img src="assets/images/icons/doughnut_chart.svg" >
                                     </span>
                                     <div class="joinerContent">
                                         <h3>15%</h3>
                                         <p>Percentage of  course completed</p>
                                     </div>
                                     
                                 </div>
                             </div>
                             <div class="col-12 col-md-4">
                                 <div class="joinerDetails mb-md-0">
                                     <span class="joinerDetailsImage">
                                         <img src="assets/images/icons/clock.svg" >
                                     </span>
                                     <div class="joinerContent">
                                         <h3>20 hr 43 min</h3>
                                         <p>Time spent on course</p>
                                     </div>
                                 </div>
                             </div>
      
                           </div>
   </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                       
                    </div>
            </mat-tab>
            <mat-tab disabled>
                <ng-template mat-tab-label>
                    <b>Module 3:</b>Introduction to Motor Engine Rerouting
                    <strong><i><svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.94252 5.29354H1.15307L1.15669 3.33606C1.20032 2.41276 1.60032 1.5852 2.22032 0.986142L2.2252 0.98126C2.85685 0.373701 3.71465 0 4.65402 0C5.59512 0 6.45528 0.374961 7.08772 0.986142C7.71921 1.59669 8.12284 2.44441 8.15354 3.38866L8.15528 5.29354H8.36551C8.6252 5.29354 8.86221 5.4 9.03181 5.56976L9.07732 5.62094C9.22079 5.78709 9.30803 6.0022 9.30803 6.23606V11.0575C9.30803 11.3172 9.20158 11.5542 9.03181 11.7238C8.86221 11.8935 8.6252 12 8.36551 12H0.94252C0.682835 12 0.445827 11.8935 0.276221 11.7238C0.106457 11.5542 0 11.3172 0 11.0575V6.23606C0 5.97858 0.105984 5.74346 0.276221 5.57197C0.445827 5.4 0.682835 5.29354 0.94252 5.29354ZM4.65402 7.00425C5.00236 7.00425 5.28472 7.28661 5.28472 7.63496C5.28472 7.91039 5.10835 8.14425 4.86236 8.23039V8.7211V9.90709C4.86236 10.0508 4.74589 10.1672 4.60221 10.1672C4.4567 10.1672 4.33874 10.0493 4.33874 9.90377V8.7211V8.23039C4.09276 8.14425 3.96008 7.91039 3.96008 7.63496C3.96008 7.28661 4.30567 7.00425 4.65402 7.00425ZM2.28362 5.29354H7.02441V3.40646C7.00079 2.77433 6.72819 2.2074 6.30551 1.79858C5.87795 1.38425 5.29543 1.13134 4.65402 1.13134C4.01307 1.13134 3.43087 1.38394 3.00551 1.79543C2.5852 2.20252 2.31386 2.76063 2.28315 3.38331L2.28362 5.29354Z" fill="white"/>
                        </svg></i></strong>
                    </ng-template>
                    <div class="contentBody">
                        <div class="pl-4 mt-4 pr-4">
                            <div class="moduleHead">
                                <b>Module 1:</b>
                                <div class="mudleSubHead">
                                <h3>Introduction to Motor Engine Rerouting</h3>
                                <ul class="modifyIcons">
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                    </li>
                                </ul>
                            </div>
                            </div>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    
                              <p class="assignOn text-left mt-2 mb-2"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                              <div class="row m-0">
                                  <div class="grapgReaWrap">
                                    <ul>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/doughnut_chart.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>15%</h3>
                                                    <p>Percentage of  course completed</p>
                                                    <div class="ghrapWrap">
                                                        <span style="width: 15%;"></span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </li>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/clock.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>20 hr 43 min</h3>
                                                    <p>Time spent on course</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/time.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>43 min</h3>
                                                    <p>Spent on assessment</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/gps.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>2/3</h3>
                                                    <p>No. of Attempts</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li class="text-right">
                                            <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border ">
                                                <span>Contact Admin</span>
                                            </a>
                                        </li>
                                    </ul>
                                  </div>
                            </div>
                        </div>
                        <hr/>
                        <div class="submudleWrap">
                        <mat-accordion>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div class="moduleHead">
                                        
                                        <div class="submudleHead">
                                            <h3 ><b>SUB MODULE 1:</b>Safety & Precautions with Barrel Engine</h3>
                                            <div class="viewpass">
                                                <a href="javascript:void(0);" class="btn-link text-uppercase">View</a>
                                                <a href="javascript:void(0);" class="btn-link-green text-uppercase">Completed</a>
                                            </div>
                                            <ul class="modifyIcons">
                                                
                                                <li>
                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    
                                <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                <div class="row m-0">
                                  <div class="col-12 col-md-4">
                                      <div class="joinerDetails mb-md-0">
                                          <span class="joinerDetailsImage">
                                              <img src="assets/images/icons/doughnut_chart.svg" >
                                          </span>
                                          <div class="joinerContent">
                                              <h3>15%</h3>
                                              <p>Percentage of  course completed</p>
                                          </div>
                                          
                                      </div>
                                  </div>
                                  <div class="col-12 col-md-4">
                                      <div class="joinerDetails mb-md-0">
                                          <span class="joinerDetailsImage">
                                              <img src="assets/images/icons/clock.svg" >
                                          </span>
                                          <div class="joinerContent">
                                              <h3>20 hr 43 min</h3>
                                              <p>Time spent on course</p>
                                          </div>
                                      </div>
                                  </div>
           
                                </div>
                            </mat-expansion-panel>
                            
                            <mat-expansion-panel (opened)="panelOpenState = true"
                                                 (closed)="panelOpenState = false">
                                                 <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <div class="moduleHead">
                                                            
                                                            <div class="submudleHead">
                                                            <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                                            <div class="viewpass">
                                                                <a href="javascript:void(0);" class="btn-link text-uppercase">View</a>
                                                                <a href="javascript:void(0);" class="btn-link-green text-uppercase">Passed</a>
                                                            </div>
                                                            <ul class="modifyIcons">
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                    </mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        
                                                    <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                    <div class="row m-0">
                                                      <div class="col-12 col-md-6">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/doughnut_chart.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>15%</h3>
                                                                  <p>Percentage of  course completed</p>
                                                              </div>
                                                              
                                                          </div>
                                                      </div>
                                                      <div class="col-12 col-md-6">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/clock.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>20 hr 43 min</h3>
                                                                  <p>Time spent on course</p>
                                                              </div>
                                                          </div>
                                                      </div>
                               
                                                    </div>
                            </mat-expansion-panel>
                            <mat-expansion-panel (opened)="panelOpenState = true"
                                                 (closed)="panelOpenState = false">
                                                 <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <div class="moduleHead">
                                                            
                                                            <div class="submudleHead">
                                                            <h3><b>SUB MODULE 2:</b>Advanced level Introduction to Barrel Engine</h3>
                                                            <div class="viewpass">
                                                                <button class="btn btn-primary">Start</button>
                                                            </div>
                                                            <ul class="modifyIcons">
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                    </mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        
                                                    <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                    <div class="row m-0">
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/doughnut_chart.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>15%</h3>
                                                                  <p>Percentage of  course completed</p>
                                                              </div>
                                                              
                                                          </div>
                                                      </div>
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/clock.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>20 hr 43 min</h3>
                                                                  <p>Time spent on course</p>
                                                              </div>
                                                          </div>
                                                      </div>
                               
                                                    </div>
                            </mat-expansion-panel>
                            <mat-expansion-panel (opened)="panelOpenState = true"
                                                 (closed)="panelOpenState = false">
                                                 <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <div class="moduleHead">
                                                            
                                                            <div class="submudleHead">
                                                            <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                                            <div class="viewpass">
                                                                
                                                                <div class="locked">
                                                                    <span mat-raised-button matTooltipClass="custom-tooltip"
                                                                            matTooltip="This section would only be unlocked once the previous section is completed by you"
                                                                            aria-label="Button that displays a tooltip when focused or hovered over">
                                                                            LOCKED
                                                                </span>
                                                                </div>
                                                            </div>
                                                            <ul class="modifyIcons">
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                    </mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        
                                                    <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                    <div class="row m-0">
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/doughnut_chart.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>15%</h3>
                                                                  <p>Percentage of  course completed</p>
                                                              </div>
                                                              
                                                          </div>
                                                      </div>
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/clock.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>20 hr 43 min</h3>
                                                                  <p>Time spent on course</p>
                                                              </div>
                                                          </div>
                                                      </div>
                               
                                                    </div>
                            </mat-expansion-panel>
                            <mat-expansion-panel (opened)="panelOpenState = true"
                            (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                               <mat-panel-title>
                                   <div class="moduleHead">
                                       
                                       <div class="submudleHead">
                                       <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                       <div class="viewpass">
                                           
                                        <button class="btn btn-primary">Start 1<sup>ST</sup> attempt</button>
                                       </div>
                                       <ul class="modifyIcons">
                                           <li>
                                               <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                           </li>
                                           <li>
                                               <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                           </li>
                                           <li>
                                               <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                           </li>
                                       </ul>
                                   </div>
                                   </div>
                               </mat-panel-title>
                               </mat-expansion-panel-header>
                               <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    
                               <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                               <div class="row m-0">
                                 <div class="col-12 col-md-4">
                                     <div class="joinerDetails mb-md-0">
                                         <span class="joinerDetailsImage">
                                             <img src="assets/images/icons/doughnut_chart.svg" >
                                         </span>
                                         <div class="joinerContent">
                                             <h3>15%</h3>
                                             <p>Percentage of  course completed</p>
                                         </div>
                                         
                                     </div>
                                 </div>
                                 <div class="col-12 col-md-4">
                                     <div class="joinerDetails mb-md-0">
                                         <span class="joinerDetailsImage">
                                             <img src="assets/images/icons/clock.svg" >
                                         </span>
                                         <div class="joinerContent">
                                             <h3>20 hr 43 min</h3>
                                             <p>Time spent on course</p>
                                         </div>
                                     </div>
                                 </div>
          
                               </div>
       </mat-expansion-panel>
                          </mat-accordion>
                        </div>
                           
                        </div>
            </mat-tab>
            <mat-tab disabled>
                <ng-template mat-tab-label>
                    <b>Module 4:</b> Beginner level Introduction to Barrel Engine
                    <strong><i><svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.94252 5.29354H1.15307L1.15669 3.33606C1.20032 2.41276 1.60032 1.5852 2.22032 0.986142L2.2252 0.98126C2.85685 0.373701 3.71465 0 4.65402 0C5.59512 0 6.45528 0.374961 7.08772 0.986142C7.71921 1.59669 8.12284 2.44441 8.15354 3.38866L8.15528 5.29354H8.36551C8.6252 5.29354 8.86221 5.4 9.03181 5.56976L9.07732 5.62094C9.22079 5.78709 9.30803 6.0022 9.30803 6.23606V11.0575C9.30803 11.3172 9.20158 11.5542 9.03181 11.7238C8.86221 11.8935 8.6252 12 8.36551 12H0.94252C0.682835 12 0.445827 11.8935 0.276221 11.7238C0.106457 11.5542 0 11.3172 0 11.0575V6.23606C0 5.97858 0.105984 5.74346 0.276221 5.57197C0.445827 5.4 0.682835 5.29354 0.94252 5.29354ZM4.65402 7.00425C5.00236 7.00425 5.28472 7.28661 5.28472 7.63496C5.28472 7.91039 5.10835 8.14425 4.86236 8.23039V8.7211V9.90709C4.86236 10.0508 4.74589 10.1672 4.60221 10.1672C4.4567 10.1672 4.33874 10.0493 4.33874 9.90377V8.7211V8.23039C4.09276 8.14425 3.96008 7.91039 3.96008 7.63496C3.96008 7.28661 4.30567 7.00425 4.65402 7.00425ZM2.28362 5.29354H7.02441V3.40646C7.00079 2.77433 6.72819 2.2074 6.30551 1.79858C5.87795 1.38425 5.29543 1.13134 4.65402 1.13134C4.01307 1.13134 3.43087 1.38394 3.00551 1.79543C2.5852 2.20252 2.31386 2.76063 2.28315 3.38331L2.28362 5.29354Z" fill="white"/>
                        </svg></i></strong>
                    </ng-template>
                    <div class="contentBody">
                        <div class="pl-4 mt-4 pr-4">
                            <div class="moduleHead">
                                <b>Module 1:</b>
                                <div class="mudleSubHead">
                                <h3>Introduction to Motor Engine Rerouting</h3>
                                <ul class="modifyIcons">
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                    </li>
                                </ul>
                            </div>
                            </div>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    
                              <p class="assignOn text-left mt-2 mb-2"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                              <div class="row m-0">
                                  <div class="grapgReaWrap">
                                    <ul>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/doughnut_chart.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>15%</h3>
                                                    <p>Percentage of  course completed</p>
                                                    <div class="ghrapWrap">
                                                        <span style="width: 15%;"></span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </li>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/clock.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>20 hr 43 min</h3>
                                                    <p>Time spent on course</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/time.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>43 min</h3>
                                                    <p>Spent on assessment</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <div class="joinerDetails mb-md-0">
                                                <span class="joinerDetailsImage">
                                                    <img src="assets/images/icons/gps.svg" >
                                                </span>
                                                <div class="joinerContent">
                                                    <h3>2/3</h3>
                                                    <p>No. of Attempts</p>
                                                </div>
                                            </div>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);" class="mudleBtn">
                                                Module Assessment 3<sup>RD</sup> Attempt </a>
                                        </li>
                                    </ul>
                                  </div>
                            </div>
                        </div>
                        <hr/>
                        <div class="submudleWrap">
                        <mat-accordion>
                            <mat-expansion-panel>
                              <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <div class="moduleHead">
                                        
                                        <div class="submudleHead">
                                            <h3 ><b>SUB MODULE 1:</b>Safety & Precautions with Barrel Engine</h3>
                                            <div class="viewpass">
                                                <a href="javascript:void(0);" class="btn-link text-uppercase">View</a>
                                                <a href="javascript:void(0);" class="btn-link-green text-uppercase">Completed</a>
                                            </div>
                                            <ul class="modifyIcons">
                                                
                                                <li>
                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                </li>
                                                <li>
                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </mat-panel-title>
                                </mat-expansion-panel-header>
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    
                                <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                <div class="row m-0">
                                  <div class="col-12 col-md-4">
                                      <div class="joinerDetails mb-md-0">
                                          <span class="joinerDetailsImage">
                                              <img src="assets/images/icons/doughnut_chart.svg" >
                                          </span>
                                          <div class="joinerContent">
                                              <h3>15%</h3>
                                              <p>Percentage of  course completed</p>
                                          </div>
                                          
                                      </div>
                                  </div>
                                  <div class="col-12 col-md-4">
                                      <div class="joinerDetails mb-md-0">
                                          <span class="joinerDetailsImage">
                                              <img src="assets/images/icons/clock.svg" >
                                          </span>
                                          <div class="joinerContent">
                                              <h3>20 hr 43 min</h3>
                                              <p>Time spent on course</p>
                                          </div>
                                      </div>
                                  </div>
           
                                </div>
                            </mat-expansion-panel>
                            
                            <mat-expansion-panel (opened)="panelOpenState = true"
                                                 (closed)="panelOpenState = false">
                                                 <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <div class="moduleHead">
                                                            
                                                            <div class="submudleHead">
                                                            <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                                            <div class="viewpass">
                                                                <a href="javascript:void(0);" class="btn-link text-uppercase">View</a>
                                                                <a href="javascript:void(0);" class="btn-link-green text-uppercase">Passed</a>
                                                            </div>
                                                            <ul class="modifyIcons">
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                    </mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        
                                                    <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                    <div class="row m-0">
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/doughnut_chart.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>15%</h3>
                                                                  <p>Percentage of  course completed</p>
                                                              </div>
                                                              
                                                          </div>
                                                      </div>
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/clock.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>20 hr 43 min</h3>
                                                                  <p>Time spent on course</p>
                                                              </div>
                                                          </div>
                                                      </div>
                               
                                                    </div>
                            </mat-expansion-panel>
                            <mat-expansion-panel (opened)="panelOpenState = true"
                                                 (closed)="panelOpenState = false">
                                                 <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <div class="moduleHead">
                                                            
                                                            <div class="submudleHead">
                                                            <h3><b>SUB MODULE 2:</b>Advanced level Introduction to Barrel Engine</h3>
                                                            <div class="viewpass">
                                                                <button class="btn btn-primary">Start</button>
                                                            </div>
                                                            <ul class="modifyIcons">
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                    </mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        
                                                    <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                    <div class="row m-0">
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/doughnut_chart.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>15%</h3>
                                                                  <p>Percentage of  course completed</p>
                                                              </div>
                                                              
                                                          </div>
                                                      </div>
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/clock.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>20 hr 43 min</h3>
                                                                  <p>Time spent on course</p>
                                                              </div>
                                                          </div>
                                                      </div>
                               
                                                    </div>
                            </mat-expansion-panel>
                            <mat-expansion-panel (opened)="panelOpenState = true"
                                                 (closed)="panelOpenState = false">
                                                 <mat-expansion-panel-header>
                                                    <mat-panel-title>
                                                        <div class="moduleHead">
                                                            
                                                            <div class="submudleHead">
                                                            <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                                            <div class="viewpass">
                                                                
                                                                <div class="locked">
                                                                    <span mat-raised-button matTooltipClass="custom-tooltip"
                                                                            matTooltip="This section would only be unlocked once the previous section is completed by you"
                                                                            aria-label="Button that displays a tooltip when focused or hovered over">
                                                                            LOCKED
                                                                </span>
                                                                </div>
                                                            </div>
                                                            <ul class="modifyIcons">
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                                </li>
                                                                <li>
                                                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                        </div>
                                                    </mat-panel-title>
                                                    </mat-expansion-panel-header>
                                                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                        
                                                    <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                    <div class="row m-0">
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/doughnut_chart.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>15%</h3>
                                                                  <p>Percentage of  course completed</p>
                                                              </div>
                                                              
                                                          </div>
                                                      </div>
                                                      <div class="col-12 col-md-4">
                                                          <div class="joinerDetails mb-md-0">
                                                              <span class="joinerDetailsImage">
                                                                  <img src="assets/images/icons/clock.svg" >
                                                              </span>
                                                              <div class="joinerContent">
                                                                  <h3>20 hr 43 min</h3>
                                                                  <p>Time spent on course</p>
                                                              </div>
                                                          </div>
                                                      </div>
                               
                                                    </div>
                            </mat-expansion-panel>
                            <mat-expansion-panel (opened)="panelOpenState = true"
                            (closed)="panelOpenState = false">
                            <mat-expansion-panel-header>
                               <mat-panel-title>
                                   <div class="moduleHead">
                                       
                                       <div class="submudleHead">
                                       <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                       <div class="viewpass">
                                           
                                        <button class="btn btn-primary">Start 1<sup>ST</sup> attempt</button>
                                       </div>
                                       <ul class="modifyIcons">
                                           <li>
                                               <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                           </li>
                                           <li>
                                               <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                           </li>
                                           <li>
                                               <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                           </li>
                                       </ul>
                                   </div>
                                   </div>
                               </mat-panel-title>
                               </mat-expansion-panel-header>
                               <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
    
                               <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                               <div class="row m-0">
                                 <div class="col-12 col-md-4">
                                     <div class="joinerDetails mb-md-0">
                                         <span class="joinerDetailsImage">
                                             <img src="assets/images/icons/doughnut_chart.svg" >
                                         </span>
                                         <div class="joinerContent">
                                             <h3>15%</h3>
                                             <p>Percentage of  course completed</p>
                                         </div>
                                         
                                     </div>
                                 </div>
                                 <div class="col-12 col-md-4">
                                     <div class="joinerDetails mb-md-0">
                                         <span class="joinerDetailsImage">
                                             <img src="assets/images/icons/clock.svg" >
                                         </span>
                                         <div class="joinerContent">
                                             <h3>20 hr 43 min</h3>
                                             <p>Time spent on course</p>
                                         </div>
                                     </div>
                                 </div>
          
                               </div>
       </mat-expansion-panel>
                          </mat-accordion>
                        </div>
                           
                        </div>
            </mat-tab>
            <mat-tab disabled>

                <ng-template mat-tab-label>
                    <b>Module 1:</b>Introduction to Motor Engine Rerouting 
                    <strong><i><svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.94252 5.29354H1.15307L1.15669 3.33606C1.20032 2.41276 1.60032 1.5852 2.22032 0.986142L2.2252 0.98126C2.85685 0.373701 3.71465 0 4.65402 0C5.59512 0 6.45528 0.374961 7.08772 0.986142C7.71921 1.59669 8.12284 2.44441 8.15354 3.38866L8.15528 5.29354H8.36551C8.6252 5.29354 8.86221 5.4 9.03181 5.56976L9.07732 5.62094C9.22079 5.78709 9.30803 6.0022 9.30803 6.23606V11.0575C9.30803 11.3172 9.20158 11.5542 9.03181 11.7238C8.86221 11.8935 8.6252 12 8.36551 12H0.94252C0.682835 12 0.445827 11.8935 0.276221 11.7238C0.106457 11.5542 0 11.3172 0 11.0575V6.23606C0 5.97858 0.105984 5.74346 0.276221 5.57197C0.445827 5.4 0.682835 5.29354 0.94252 5.29354ZM4.65402 7.00425C5.00236 7.00425 5.28472 7.28661 5.28472 7.63496C5.28472 7.91039 5.10835 8.14425 4.86236 8.23039V8.7211V9.90709C4.86236 10.0508 4.74589 10.1672 4.60221 10.1672C4.4567 10.1672 4.33874 10.0493 4.33874 9.90377V8.7211V8.23039C4.09276 8.14425 3.96008 7.91039 3.96008 7.63496C3.96008 7.28661 4.30567 7.00425 4.65402 7.00425ZM2.28362 5.29354H7.02441V3.40646C7.00079 2.77433 6.72819 2.2074 6.30551 1.79858C5.87795 1.38425 5.29543 1.13134 4.65402 1.13134C4.01307 1.13134 3.43087 1.38394 3.00551 1.79543C2.5852 2.20252 2.31386 2.76063 2.28315 3.38331L2.28362 5.29354Z" fill="white"/>
                        </svg></i></strong>
                </ng-template>
              
                <div class="contentBody">
                    <div class="pl-4 mt-4 pr-4">
                        <div class="moduleHead">
                            <b>Module 4:</b>
                            <div class="mudleSubHead">
                            <h3>Introduction to Motor Engine Rerouting</h3>
                            <ul class="modifyIcons">
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/frame.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                </li>
                                <li>
                                    <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                </li>
                            </ul>
                        </div>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

                          <p class="assignOn text-left mt-2 mb-2"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                          <div class="row m-0">
                              <div class="grapgReaWrap">
                                <ul>
                                    <li>
                                        <div class="joinerDetails mb-md-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/doughnut_chart.svg" >
                                            </span>
                                            <div class="joinerContent">
                                                <h3>15%</h3>
                                                <p>Percentage of  course completed</p>
                                                <div class="ghrapWrap">
                                                    <span style="width: 15%;"></span>
                                                </div>
                                            </div>
                                            
                                        </div>
                                    </li>
                                    <li>
                                        <div class="joinerDetails mb-md-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/clock.svg" >
                                            </span>
                                            <div class="joinerContent">
                                                <h3>20 hr 43 min</h3>
                                                <p>Time spent on course</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="joinerDetails mb-md-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/time.svg" >
                                            </span>
                                            <div class="joinerContent">
                                                <h3>43 min</h3>
                                                <p>Spent on assessment</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="joinerDetails mb-md-0">
                                            <span class="joinerDetailsImage">
                                                <img src="assets/images/icons/gps.svg" >
                                            </span>
                                            <div class="joinerContent">
                                                <h3>2/3</h3>
                                                <p>No. of Attempts</p>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="text-right">
                                        <a href="javascript:void(0);" class="greenBtn">
                                            <b>
                                                <img src="assets/images/icons/w_tick.svg">
                                            </b> Assessment Passed </a>
                                    </li>
                                </ul>
                              </div>
                        </div>
                    </div>
                    <hr/>
                    <div class="submudleWrap">
                    <mat-accordion>
                        <mat-expansion-panel>
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                                <div class="moduleHead">
                                    <div class="submudleHead">
                                        <h3 ><b>SUB MODULE 1:</b>Safety & Precautions with Barrel Engine</h3>
                                        <div class="viewpass">
                                            <a href="javascript:void(0);" [routerLink]="['/viewer']" class="btn-link text-uppercase">View</a>
                                            <a href="javascript:void(0);" class="btn-link-green text-uppercase">Completed</a>
                                        </div>
                                        <ul class="modifyIcons">
                                            
                                            <li>
                                                <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </mat-panel-title>
                            </mat-expansion-panel-header>
                            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                            <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                            <div class="row m-0">
                              <div class="col-12 col-md-4">
                                  <div class="joinerDetails mb-md-0">
                                      <span class="joinerDetailsImage">
                                          <img src="assets/images/icons/doughnut_chart.svg" >
                                      </span>
                                      <div class="joinerContent">
                                          <h3>15%</h3>
                                          <p>Percentage of  course completed</p>
                                      </div>
                                    </div>
                              </div>
                              <div class="col-12 col-md-4">
                                  <div class="joinerDetails mb-md-0">
                                      <span class="joinerDetailsImage">
                                          <img src="assets/images/icons/clock.svg" >
                                      </span>
                                      <div class="joinerContent">
                                          <h3>20 hr 43 min</h3>
                                          <p>Time spent on course</p>
                                      </div>
                                  </div>
                              </div>
       
                            </div>
                        </mat-expansion-panel>
                        
                        <mat-expansion-panel (opened)="panelOpenState = true"
                                             (closed)="panelOpenState = false">
                                             <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <div class="moduleHead">
                                                        <div class="submudleHead">
                                                        <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                                        <div class="viewpass">
                                                            <a href="javascript:void(0);" [routerLink]="['/viewer']" class="btn-link text-uppercase">View</a>
                                                            <a href="javascript:void(0);" class="btn-link-green text-uppercase">Passed</a>
                                                        </div>
                                                        <ul class="modifyIcons">
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    </div>
                                                </mat-panel-title>
                                                </mat-expansion-panel-header>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                                <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                <div class="row m-0">
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/doughnut_chart.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>15%</h3>
                                                              <p>Percentage of  course completed</p>
                                                          </div>
                                                      </div>
                                                  </div>
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/clock.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>20 hr 43 min</h3>
                                                              <p>Time spent on course</p>
                                                          </div>
                                                      </div>
                                                  </div>
                           
                                                </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true"
                                             (closed)="panelOpenState = false">
                                             <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <div class="moduleHead">
                                                        
                                                        <div class="submudleHead">
                                                        <h3><b>SUB MODULE 2:</b>Advanced level Introduction to Barrel Engine</h3>
                                                        <div class="viewpass">
                                                            <button class="btn btn-primary">Start</button>
                                                        </div>
                                                        <ul class="modifyIcons">
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    </div>
                                                </mat-panel-title>
                                                </mat-expansion-panel-header>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    
                                                <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                <div class="row m-0">
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/doughnut_chart.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>15%</h3>
                                                              <p>Percentage of  course completed</p>
                                                          </div>
                                                          
                                                      </div>
                                                  </div>
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/clock.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>20 hr 43 min</h3>
                                                              <p>Time spent on course</p>
                                                          </div>
                                                      </div>
                                                  </div>
                           
                                                </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true"
                                             (closed)="panelOpenState = false">
                                             <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <div class="moduleHead">
                                                        
                                                        <div class="submudleHead">
                                                        <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                                        <div class="viewpass">
                                                            
                                                            <div class="locked">
                                                                <span mat-raised-button matTooltipClass="custom-tooltip"
                                                                        matTooltip="This section would only be unlocked once the previous section is completed by you"
                                                                        aria-label="Button that displays a tooltip when focused or hovered over">
                                                                        LOCKED
                                                            </span>
                                                            </div>
                                                        </div>
                                                        <ul class="modifyIcons">
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    </div>
                                                </mat-panel-title>
                                                </mat-expansion-panel-header>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    
                                                <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                <div class="row m-0">
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/doughnut_chart.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>15%</h3>
                                                              <p>Percentage of  course completed</p>
                                                          </div>
                                                          
                                                      </div>
                                                  </div>
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/clock.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>20 hr 43 min</h3>
                                                              <p>Time spent on course</p>
                                                          </div>
                                                      </div>
                                                  </div>
                           
                                                </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true"
                                             (closed)="panelOpenState = false">
                                             <mat-expansion-panel-header>
                                                <mat-panel-title>
                                                    <div class="moduleHead">
                                                        
                                                        <div class="submudleHead">
                                                        <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                                        <div class="viewpass">
                                                            
                                                            <div class="locked">
                                                               <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border">
                                                                <span mat-raised-button matTooltipClass="custom-tooltip"
                                                                        matTooltip="This section would only be unlocked once the previous section is completed by you"
                                                                        aria-label="Button that displays a tooltip when focused or hovered over">
                                                                        Contact Admin
                                                            </span>
                                                            </a>
                                                            </div>

                                                        </div>
                                                        <ul class="modifyIcons">
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                                            </li>
                                                            <li>
                                                                <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                    </div>
                                                </mat-panel-title>
                                                </mat-expansion-panel-header>
                                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                    
                                                <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                                                <div class="row m-0">
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/doughnut_chart.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>15%</h3>
                                                              <p>Percentage of  course completed</p>
                                                          </div>
                                                          
                                                      </div>
                                                  </div>
                                                  <div class="col-12 col-md-4">
                                                      <div class="joinerDetails mb-md-0">
                                                          <span class="joinerDetailsImage">
                                                              <img src="assets/images/icons/clock.svg" >
                                                          </span>
                                                          <div class="joinerContent">
                                                              <h3>20 hr 43 min</h3>
                                                              <p>Time spent on course</p>
                                                          </div>
                                                      </div>
                                                  </div>
                           
                                                </div>
                        </mat-expansion-panel>
                        <mat-expansion-panel (opened)="panelOpenState = true"
                        (closed)="panelOpenState = false">
                        <mat-expansion-panel-header>
                           <mat-panel-title>
                               <div class="moduleHead">
                                   
                                   <div class="submudleHead">
                                   <h3><b>SUB MODULE 2:</b>Beginner level Introduction to Barrel Engine</h3>
                                   <div class="viewpass">
                                       
                                    <button class="btn btn-primary">Start 1<sup>ST</sup> attempt</button>
                                   </div>
                                   <ul class="modifyIcons">
                                       <li>
                                           <a href="javascript:void(0);"><img src="assets/images/icons/text.svg" /></a>
                                       </li>
                                       <li>
                                           <a href="javascript:void(0);"><img src="assets/images/icons/insert-picture.svg" /></a>
                                       </li>
                                       <li>
                                           <a href="javascript:void(0);"><img src="assets/images/icons/video-camera.svg" /></a>
                                       </li>
                                   </ul>
                               </div>
                               </div>
                           </mat-panel-title>
                           </mat-expansion-panel-header>
                           <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>

                           <p class="assignOn text-left"><span>Start Date: 24 Dec, 2020</span><span>Last Viewed: 27 Dec,2020</span></p>
                           <div class="row m-0">
                             <div class="col-12 col-md-6">
                                 <div class="joinerDetails mb-md-0">
                                     <span class="joinerDetailsImage">
                                         <img src="assets/images/icons/doughnut_chart.svg" >
                                     </span>
                                     <div class="joinerContent">
                                         <h3>15%</h3>
                                         <p>Percentage of  course completed</p>
                                     </div>
                                     
                                 </div>
                             </div>
                             <div class="col-12 col-md-6">
                                 <div class="joinerDetails mb-md-0">
                                     <span class="joinerDetailsImage">
                                         <img src="assets/images/icons/clock.svg" >
                                     </span>
                                     <div class="joinerContent">
                                         <h3>20 hr 43 min</h3>
                                         <p>Time spent on course</p>
                                     </div>
                                 </div>
                             </div>
      
                           </div>
   </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                    
                        
                        
                        
                    </div>
            </mat-tab>
           
            <mat-tab disabled>
                <ng-template mat-tab-label>
                    <b>Module 5:</b>Introduction to Motor Engine Rerouting
                    <strong><i><svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.94252 5.29354H1.15307L1.15669 3.33606C1.20032 2.41276 1.60032 1.5852 2.22032 0.986142L2.2252 0.98126C2.85685 0.373701 3.71465 0 4.65402 0C5.59512 0 6.45528 0.374961 7.08772 0.986142C7.71921 1.59669 8.12284 2.44441 8.15354 3.38866L8.15528 5.29354H8.36551C8.6252 5.29354 8.86221 5.4 9.03181 5.56976L9.07732 5.62094C9.22079 5.78709 9.30803 6.0022 9.30803 6.23606V11.0575C9.30803 11.3172 9.20158 11.5542 9.03181 11.7238C8.86221 11.8935 8.6252 12 8.36551 12H0.94252C0.682835 12 0.445827 11.8935 0.276221 11.7238C0.106457 11.5542 0 11.3172 0 11.0575V6.23606C0 5.97858 0.105984 5.74346 0.276221 5.57197C0.445827 5.4 0.682835 5.29354 0.94252 5.29354ZM4.65402 7.00425C5.00236 7.00425 5.28472 7.28661 5.28472 7.63496C5.28472 7.91039 5.10835 8.14425 4.86236 8.23039V8.7211V9.90709C4.86236 10.0508 4.74589 10.1672 4.60221 10.1672C4.4567 10.1672 4.33874 10.0493 4.33874 9.90377V8.7211V8.23039C4.09276 8.14425 3.96008 7.91039 3.96008 7.63496C3.96008 7.28661 4.30567 7.00425 4.65402 7.00425ZM2.28362 5.29354H7.02441V3.40646C7.00079 2.77433 6.72819 2.2074 6.30551 1.79858C5.87795 1.38425 5.29543 1.13134 4.65402 1.13134C4.01307 1.13134 3.43087 1.38394 3.00551 1.79543C2.5852 2.20252 2.31386 2.76063 2.28315 3.38331L2.28362 5.29354Z" fill="white"/>
                        </svg></i></strong>
                    </ng-template>
                Content 5
            </mat-tab>
          </mat-tab-group>
    </div>


    

</div>

<ng-template #content let-modal>
    
    <div class="modal-body">
      
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
              </button>
            <figure>
                <img src="assets/images/hourglass.png">
            </figure>
            <h6>Hold Tight!</h6>
            <p>Your request to increase the number of attempts available for assessments, has been sent to the administrator for review and approval.</p>
        
        <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border" (click)="modal.close('Close click')">
            <span>Close</span>
        </a>
    </div>
    </div>
  </ng-template>
  
   
  
 
